/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_typing_hub_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How is typing speed (WPM) calculated?`)
};

const es_typing_hub_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cómo se calcula la velocidad de mecanografía (WPM)?`)
};

const de_typing_hub_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie wird die Tippgeschwindigkeit (WPM) berechnet?`)
};

const nl_typing_hub_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoe wordt de typsnelheid (WPM) berekend?`)
};

const fr_typing_hub_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment la vitesse de frappe (WPM) est-elle calculée ?`)
};

const it_typing_hub_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Come si calcola la velocità di digitazione (WPM)?`)
};

const pt_br2_typing_hub_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como a velocidade de digitação (WPM) é calculada?`)
};

const pt_typing_hub_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como é calculada a velocidade de escrita (WPM)?`)
};

const ja_typing_hub_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タイピング速度（WPM）はどのように計算されますか？`)
};

const zh_typing_hub_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打字速度（WPM）是如何计算的？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const typing_hub_faq1_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.typing_hub_faq1_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("typing_hub_faq1_q", locale)
	if (locale === "en") return en_typing_hub_faq1_q(inputs)
	if (locale === "es") return es_typing_hub_faq1_q(inputs)
	if (locale === "de") return de_typing_hub_faq1_q(inputs)
	if (locale === "nl") return nl_typing_hub_faq1_q(inputs)
	if (locale === "fr") return fr_typing_hub_faq1_q(inputs)
	if (locale === "it") return it_typing_hub_faq1_q(inputs)
	if (locale === "pt-BR") return pt_br2_typing_hub_faq1_q(inputs)
	if (locale === "pt") return pt_typing_hub_faq1_q(inputs)
	if (locale === "ja") return ja_typing_hub_faq1_q(inputs)
	return zh_typing_hub_faq1_q(inputs)
};